module.exports = __webpack_public_path__ + "img/color2_logo_transparent_background.e1d0d4ef.png";